import { render, staticRenderFns } from "./FrameToComeInfoReview.vue?vue&type=template&id=8ee25812"
import script from "./FrameToComeInfoReview.vue?vue&type=script&lang=js"
export * from "./FrameToComeInfoReview.vue?vue&type=script&lang=js"
import style0 from "./FrameToComeInfoReview.vue?vue&type=style&index=0&id=8ee25812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports